import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LangContext";
import { Mail, MapPin } from "lucide-react";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-grafite text-pietra-light/80 pt-20 pb-10 relative overflow-hidden">
      <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-miele/60 to-transparent" />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-16">
          <div className="md:col-span-2">
            <div className="flex items-center gap-4 mb-4">
              <img
                src="/images/ibleo-cammino-unesco-logo-white.png"
                alt="Cammino Ibleo UNESCO"
                data-testid="footer-logo"
                className="h-24 w-auto flex-shrink-0 drop-shadow-[0_2px_12px_rgba(0,0,0,0.3)]"
                draggable="false"
              />
              <div className="min-w-0">
                <div className="text-[0.65rem] tracking-[0.3em] uppercase opacity-80 whitespace-nowrap text-pietra-light">Sicilia Orientale</div>
                <div className="text-[0.6rem] tracking-[0.25em] uppercase opacity-55 whitespace-nowrap mt-1">UNESCO · Monti Iblei</div>
              </div>
            </div>
            <p className="font-serif text-2xl leading-snug text-pietra-light/90 max-w-md mb-6 italic">
              {t("footer_tagline")}
            </p>
            <p className="text-xs leading-relaxed opacity-60 max-w-md">{t("footer_legal_note")}</p>
          </div>

          <div>
            <div className="small-caps text-miele mb-4">Navigate</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/cammino" className="hover:text-miele">{t("nav_cammino")}</Link></li>
              <li><Link to="/tappe" className="hover:text-miele">{t("nav_tappe")}</Link></li>
              <li><Link to="/territorio" className="hover:text-miele">{t("nav_territorio")}</Link></li>
              <li><Link to="/prodotti" className="hover:text-miele">{t("nav_prodotti")}</Link></li>
              <li><Link to="/progetto" className="hover:text-miele">{t("nav_progetto")}</Link></li>
            </ul>
          </div>

          <div>
            <div className="small-caps text-miele mb-4">Contatti</div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2"><Mail size={14} className="mt-1 opacity-70" /> <a href="mailto:alessandroveca0@gmail.com" data-testid="footer-email" className="hover:text-miele">alessandroveca0@gmail.com</a></li>
              <li className="flex items-start gap-2"><MapPin size={14} className="mt-1 opacity-70" /> Sicilia Orientale, Italia</li>
              <li><a href="https://www.alessandrovecaphotographer.net/" target="_blank" rel="noopener noreferrer" data-testid="footer-veca-link" className="text-miele hover:underline">Alessandro Veca Photographer ↗</a></li>
              <li><Link to="/diventa-partner" className="text-miele hover:underline">{t("nav_partner")} →</Link></li>
            </ul>
          </div>
        </div>

        <div className="railway-line opacity-30 mb-6" />
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs opacity-60">
          <div>© {new Date().getFullYear()} Cammino Ibleo UNESCO — {t("footer_rights")}</div>
          <div className="flex gap-6"><span>Privacy</span></div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
